import React, { useState, useEffect, useRef } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import Button from "react-bootstrap/Button";
import './Resume.css';

pdfjs.GlobalWorkerOptions.workerSrc =
  `https://unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;

const Resume = () => {
  const resumeRef = useRef(null);
  const [width, setWidth] = useState(1200);
  const [numPages, setNumPages] = useState(null);

  const pdf_file = "/Resume.pdf"

  console.log("📄 PDF file path:", pdf_file)
  console.log("📄 Current numPages:", numPages);

  useEffect(() => {
    setWidth(window.innerWidth);

    const observer = new IntersectionObserver((entries) => {
      const [entry] = entries;
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }, {
      threshold: 0.2,
    });

    const currentRef = resumeRef.current; // copy ref value here

    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <section className="resume-section" id="resume">
      <div ref={resumeRef} className="resume-container">
        <div className="resume-content">
          <div className="resume-title">
            <h1>Download My 
              <span className="gradient"> Resume </span>
            </h1>
            <Button
              variant="primary"
              href={pdf_file}
              target="_blank"
              className="download-button" 
              style={{ justifyContent: "center", position: "relative"}}
            >
              <i className="fas fa-download"></i> Download Resume 
            </Button>
          </div>
          <div className="resume-pdf">
            <Document 
              file={pdf_file} 
              className="pdf-document"
              loading="Loading Resume..."
              onLoadSuccess= {(pdf) =>{
                setNumPages(pdf.numPages);
              }}
              onLoadError={() =>
                setNumPages(null)
              }
            >
              {/* Render all pages dynamically */}
              {numPages ? (
                Array.from({ length: numPages }, (_, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    scale={width > 786 ? 1.0 : 0.6}
                    className="pdf-page"
                    renderTextLayer={false}
                    renderAnnotationLayer={false}
                  />
                ))
              ) : (
                <p>Preparing pages...</p>
              )}
            </Document>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;